module.exports = __webpack_public_path__ + "static/media/ST 11.4fb6ad27.jpg";